import React from "react";
import moment from "moment";
import { BooleanField, Datagrid, FunctionField, List, ReferenceField, ShowButton, TextField } from "react-admin";
import { useAppSelector } from "../../store/hooks";
import GoogleMapsField from "../Common/GoogleMapsField";
import ResourceSelectDialogButton from "../Common/ResourceSelectDialogButton";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
    { type: "text", label: "Search by area Name", source: "areaName" },
    { type: "text", label: "Search by city name", source: "cityName" },
    { type: "text", label: "Search by locality name", source: "name" },
]
interface LocalityListProps{
  isMultiSelect?:boolean;
}
const LocalityList = (props:LocalityListProps) => {
    const isCustomSelectOpen = useAppSelector((state) => state.customSelect.value.open);
    const checkMultiSelect = ():React.ReactElement | false => {
      return props.isMultiSelect?<></>:false
    }
    return (
      <>
        <List
            disableSyncWithLocation={props?.isMultiSelect ?? false}
            sx={{
              "& .RaList-content": {
                boxShadow: "none",
                backgroundColor: "transparent",
              },
            }}
        >
            <>
            <CommonFilterCard fields={filterFields} />

            <br />

            <StyledDatagridWrapper title="Localities">
            <Datagrid bulkActionButtons={checkMultiSelect()} sx={commonDatagridSx}>
                {
                    isCustomSelectOpen && (!props?.isMultiSelect ?? true) &&
                    <ResourceSelectDialogButton />
                }
                <TextField source="id" />
                <TextField source="name" />
                <ReferenceField source="areaId" link="show" reference="Areas">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="cityId" link="show" reference="Cities">
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="rentPayingCapacity" />
                <GoogleMapsField source="coordinates" />
                <BooleanField source="isServiceable" />
                <FunctionField label="Created At" render={(record: any) => record?.createdAt ? moment(record.createdAt).format('DD MMM YYYY') : '-'} />
                <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? moment(record.updatedAt).format('DD MMM YYYY') : '-'} />
                <ShowButton />
            </Datagrid>
            </StyledDatagridWrapper>
            </>
        </List>
        </>
    )
}

export default LocalityList;
